export default __webpack_public_path__ + "static/media/table.fe442be2.png";